<div class="relative w-full h-[64px] flex px-[38px]  justify-start items-center bg-black z-20">
    <div class="flex w-auto h-[48px] justify-center items-center gap-[10px]">
        <img src="png/ArrowLeft.svg" alt="icon" class="object-contain w-[24px] h-[24px] cursor-pointer">
        <h2 class="text-[#FCFCFD] font-manrope text-[18px] font-bold leading-[120%]">{{'Back' | translate}}</h2>
    </div>
</div>

<div class="w-full h-[450px] relative" [style.backgroundImage]="'url(png/Premium-Calculator-Asahi-Income-Protection.png)'"
    style="background-size: cover; background-position: center;">
    <div class="absolute mt-[40px] px-[40px] items-start w-[300px] h-auto">
        <div class="absolute flex flex-col items-start gap-4 z-10">
            <!-- <span
                class="self-stretch text-[#013F24] font-[manrope] text-[10px] font-extrabold leading-[120%] tracking-[2px] uppercase"
                style="font-feature-settings: 'liga' off, 'clig' off;">{{'Instant' | translate}}</span> -->
            <h1 class="self-stretch text-white font-[manrope] text-[20px] font-bold leading-[140%]">{{'Instant premium check – long-term peace of mind' | translate}}</h1>
            <p class="flex-1 text-[#121212] font-[manrope] text-[12px] font-medium leading-[140%]">{{'Easily calculate your premium and find the plan that fits your demand' | translate}}</p>
            <div
                class="flex justify-center items-start gap-[10px] p-[8px_12px] rounded-[8px] bg-[#2AD189] shadow-[0_4px_4px_0_rgba(0,0,0,0.08)] hover:bg-[#A4FFD6] transition-colors duration-300" (click)="onCheck()">
                <button class="text-[#121212] font-[manrope] text-[16px] font-bold leading-6 tracking-[-0.2px]">{{'CHECK NOW' | translate}}</button>
            </div>
        </div>
    </div>
</div>

<div class="relative form-container">
    <div class="bg-[#0E0B0C] mb-4 p-4 w-full h-auto">
        <p class="font-primary text-slate-white text-3xl text-left">{{'Secure your future against life\'s unpredictable
            risks'| translate}}
        </p>
        <hr class="opacity-60 my-4 border-gray-700 border-t" />

        <div class="mb-36 font-primary">
            <form [formGroup]="form">

                <!-- Name -->
                <div class="shadow-lg mx-auto mb-8 rounded-lg max-w-md">
                    <label class="block mb-2 text-slate-white text-base" for="name">{{'What is your name?' |
                        translate}}</label>
                    <input type="text" id="name" formControlName="name" [placeholder]="'Enter your name' | translate"
                        class="bg-[#121212] px-4 py-4 border border-[#3C3C3C99] rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary w-full text-slate-300 text-lg appearance-none" />
                    @if (form.get('name')?.invalid && (form.get('name')?.touched || form.get('name')?.dirty)) {
                    <div class="mt-1 text-[#F03457] text-sm">
                        @if (form.get('name')?.errors?.['required']) {
                        <span class="ml-2">{{'Name is required.' | translate}}</span>
                        }
                    </div>}
                </div>

                <!-- Phone -->
                <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                    @if (userDetails?.mobileNo && form.get('phone')?.value !== 'no') {
                    <label class="block mb-2 text-slate-white text-base">
                        {{'Are you still using' | translate}} {{userDetails.mobileNo}}?
                    </label>
                    <div class="flex items-center gap-2 mb-3">
                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer"
                            [ngClass]="{'border-secondary text-secondary': form.get('phone')?.value === 'yes'}">
                            <input type="radio" formControlName="phone" value="yes" class="hidden" />{{'Yes' |
                            translate}}
                        </label>
                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer"
                            [ngClass]="{'border-secondary text-secondary': form.get('phone')?.value === 'no'}">
                            <input type="radio" formControlName="phone" value="no" class="hidden" />{{'No' | translate}}
                        </label>
                    </div>
                    }
                    @if (form.get('phone')?.value === 'no' || !userDetails?.mobileNo) {
                    <div class="relative">
                        <label class="block mb-2 text-slate-white text-base">{{'Your phone number' | translate}}</label>
                        <div
                            class="flex items-center bg-[#121212] px-4 border border-[#3C3C3C99] rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary w-full text-slate-300 text-lg appearance-none">
                            <select class="bg-transparent pr-2 focus:outline-none text-slate-300 text-base"
                                style="width: 70px" [(ngModel)]="selectedCountryCode"
                                [ngModelOptions]="{standalone: true}">
                                <option value="+84">+84</option>
                                <option value="+91">+91</option>
                                <option value="+1">+1</option>
                            </select>
                            <input #phoneInput type="text" id="mobileNo" formControlName="mobileNo"
                                [placeholder]="'(555) 000-0000'"
                                class="bg-[#121212] px-4 py-4 rounded-lg focus:outline-none w-full text-slate-300 text-lg appearance-none"
                                (input)="formatPhone($event)" />

                            <!-- Show verify button only if not verified or if phone number changed -->
                            <button *ngIf="!phoneVerified || form.get('mobileNo')?.value !== verifiedPhoneNumber"
                                type="button"
                                class="flex items-center p-2 border border-[#2AD189] rounded-lg focus:outline-none font-medium text-[#2AD189] hover:underline text-nowrap"
                                [disabled]="form.get('mobileNo')?.invalid" (click)="onVerifyPhone()">
                                <span class="text-[#2AD189] underline">
                                    {{'Get Verified' | translate}}
                                </span>
                            </button>

                            <!-- Show green check icon when verified and phone number hasn't changed -->
                            <div *ngIf="phoneVerified && form.get('mobileNo')?.value === verifiedPhoneNumber"
                                class="flex items-center text-[#2AD189] text-nowrap">
                                <span class="font-medium text-[#2AD189]">
                                    {{'Verified' | translate}}
                                </span>
                                <span class="ml-2 text-[#2AD189]">
                                    <svg width="20" height="20" viewBox="0 0 32 32" fill="none"
                                        class="text-[#2AD189] transition-colors duration-200">
                                        <circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="3" />
                                        <path d="M11 16.5L15 20L21 14" stroke="currentColor" stroke-width="3"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    }

                    @if (form.get('mobileNo')?.invalid && (form.get('mobileNo')?.touched ||
                    form.get('mobileNo')?.dirty)) {
                    <div class="mt-1 text-[#F03457] text-sm">
                        @if (form.get('mobileNo')?.errors?.['required']) {
                        <span class="ml-2">{{'Phone number is required.'|translate}}</span>
                        }
                        @if (form.get('mobileNo')?.errors?.['pattern'] ||
                        form.get('mobileNo')?.errors?.['invalidPhone']) {
                        <span
                            *ngIf="form.get('mobileNo')?.errors?.['pattern'] || form.get('newPhone')?.errors?.['invalidPhone']">
                            {{'Please enter a valid 10-digit phone number.' | translate}}
                        </span>
                        }
                    </div>
                    }
                </div>

                <!-- Year -->
                <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                    <label class="block mb-2 text-slate-white text-base">{{'What is your year of birth?' |
                        translate}}</label>
                    <div class="relative w-full" (click)="toggleDropdown('calender')">
                        <app-calendar-picker [active]="activeDropdown" [asahi]="false"
                            [placeholder]="'What is your year of birth?' | translate" [showIcon]="true"
                            (closeActive)="closeDropdown()" (dateSelected)="onDateSelected($event)">
                        </app-calendar-picker>
                    </div>
                    @if (form.get('yearOfBirth')?.invalid && (form.get('yearOfBirth')?.touched ||
                    form.get('yearOfBirth')?.dirty)) {
                    <div class="mt-1 text-[#F03457] text-sm">
                        @if (form.get('yearOfBirth')?.errors?.['required']) {
                        <span class="ml-2">{{'Year is required.'|translate}}</span>
                        }
                    </div>
                    }
                    @if (form.get('yearOfBirth')?.errors?.['invalidYear']) {
                    <div class="text-[#F03457] text-sm">
                        <span class="ml-2">{{ 'Future dates are not allowed for Date of Birth' | translate }}</span>
                    </div>
                    }
                </div>
                <!-- Gender Selection -->
                <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                    <label class="block mb-2 text-slate-white text-base">
                        {{'What is your gender?' | translate}}
                    </label>
                    <div class="flex items-center gap-2 mb-3">
                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer"
                            [ngClass]="{'border-secondary text-secondary': form.get('gender')?.value === 'MALE'}">
                            <input type="radio" formControlName="gender" value="MALE" class="hidden" />{{'MALE' |
                            translate}}
                        </label>
                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer"
                            [ngClass]="{'border-secondary text-secondary': form.get('gender')?.value === 'FEMALE'}">
                            <input type="radio" formControlName="gender" value="FEMALE" class="hidden" />{{'FEMALE' |
                            translate}}
                        </label>
                    </div>
                    @if (form.get('gender')?.invalid && (form.get('gender')?.touched ||
                    form.get('gender')?.dirty)) {
                    <div class="mt-1 text-[#F03457] text-sm">
                        @if (form.get('gender')?.errors?.['required']) {
                        <span class="ml-2">{{'Gender is required.'|translate}}</span>
                        }
                    </div>
                    }
                </div>
                <!-- Income Selection -->
                <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                    <label class="block mb-2 text-slate-white text-base">
                        {{'Which range is your monthly average income?' | translate}}
                    </label>

                    <div class="flex flex-wrap gap-2 mb-3">
                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': form.get('averageMonthlyIncome')?.value === 'Less than 10 mil'}">
                            <input type="radio" formControlName="averageMonthlyIncome" value="Less than 10 mil"
                                class="hidden" />
                            {{'Less than 10 mil' | translate}}
                        </label>

                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': form.get('averageMonthlyIncome')?.value === '10 mil to less than 20 mil'}">
                            <input type="radio" formControlName="averageMonthlyIncome"
                                value="10 mil to less than 20 mil" class="hidden" />
                            {{'10 mil to less than 20 mil' | translate}}
                        </label>

                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': form.get('averageMonthlyIncome')?.value === '20 mil to less than 30 mil'}">
                            <input type="radio" formControlName="averageMonthlyIncome"
                                value="20 mil to less than 30 mil" class="hidden" />
                            {{'20 mil to less than 30 mil' | translate}}
                        </label>

                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': form.get('averageMonthlyIncome')?.value === 'Equal to or more than 30 mil'}">
                            <input type="radio" formControlName="averageMonthlyIncome"
                                value="Equal to or more than 30 mil" class="hidden" />
                            {{'Equal to or more than 30 mil' | translate}}
                        </label>
                    </div>
                    @if (form.get('averageMonthlyIncome')?.invalid && (form.get('averageMonthlyIncome')?.touched ||
                    form.get('averageMonthlyIncome')?.dirty)) {
                    <div class="mt-1 text-[#F03457] text-sm">
                        @if (form.get('averageMonthlyIncome')?.errors?.['required']) {
                        <span class="ml-2">{{'Average Monthly Income is required.'|translate}}</span>
                        }
                    </div>
                    }
                </div>
                <!-- Occupation Selection -->
                <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                    <label class="block mb-2 text-slate-white text-base">{{'What is your current occupation?' |
                        translate}}</label>
                    <div class="relative dropdown-container">
                        <button type="button"
                            class="bg-[#18171A] shadow px-4 py-3 border-none rounded-xl focus:outline-none w-full text-white text-left"
                            (click)="toggleDropdown('Occupation')">
                            <span class="text-slate-300">
                                {{ selectedOcuupation || ('Select Occupation' | translate) }}
                            </span>
                            <span class="float-right">&#9662;</span>
                        </button>
                        <div *ngIf="activeDropdown === 'Occupation'"
                            class="z-10 absolute bg-[#18171A] shadow-lg mt-2 border border-[#232124] rounded-xl w-full max-h-60 overflow-y-auto">
                            <div *ngFor="let item of occupation" (click)="selectOcuupation(item);closeDropdown()"
                                class="hover:bg-[#232124] px-4 py-2 rounded-xl cursor-pointer"
                                [ngClass]="item === selectedOcuupation ? 'text-[#F03457] font-semibold' : 'text-white'">
                                {{ item |translate }}
                            </div>
                        </div>

                    </div>
                    @if (form.get('occupation')?.invalid && (form.get('occupation')?.touched ||
                    form.get('occupation')?.dirty)) {
                    <div class="mt-1 text-[#F03457] text-sm">
                        @if (form.get('occupation')?.errors?.['required']) {
                        <span class="ml-2">{{'Occupation is required.'|translate}}</span>
                        }
                    </div>
                    }
                </div>

                <!-- Insurance Selection -->
                <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                    <label class="block mb-2 text-slate-white text-base">
                        {{'Who do you want to buy insurance for?' | translate}}
                    </label>

                    <div class="flex flex-wrap gap-2 mb-3">
                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': insuranceFor.includes('SELF')}">
                            <input type="checkbox" [checked]="insuranceFor.includes('SELF')"
                                (change)="toggleSelection('SELF')" class="hidden" />
                            {{'For myself' | translate}}
                        </label>

                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': insuranceFor.includes('FAMILY')}">
                            <input type="checkbox" [checked]="insuranceFor.includes('FAMILY')"
                                (change)="toggleSelection('FAMILY')" class="hidden" />
                            {{'For my family' | translate}}
                        </label>

                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': insuranceFor.includes('FRIENDS')}">
                            <input type="checkbox" [checked]="insuranceFor.includes('FRIENDS')"
                                (change)="toggleSelection('FRIENDS')" class="hidden" />
                            {{'For my friends' | translate}}
                        </label>

                        <label
                            class="flex justify-center items-center px-6 py-2 border rounded-full font-medium text-[14px] text-gray-300 cursor-pointer w-auto"
                            [ngClass]="{'border-secondary text-secondary': insuranceFor.includes('OTHERS')}">
                            <input type="checkbox" [checked]="insuranceFor.includes('OTHERS')"
                                (change)="toggleSelection('OTHERS')" class="hidden" />
                            {{'Other' | translate}}
                        </label>
                    </div>
                    @if (form.get('insuranceFor')?.invalid && (form.get('insuranceFor')?.touched ||
                    form.get('insuranceFor')?.dirty)) {
                    <div class="mt-1 text-[#F03457] text-sm">
                        @if (form.get('insuranceFor')?.errors?.['required']) {
                        <span class="ml-2">{{'Insurance For is required.'|translate}}</span>
                        }
                    </div>
                    }
                </div>
                <!-- Conditional dropdown -->
                <div *ngIf="showInsuranceForOthers"
                    class="shadow-lg mx-auto mb-4 rounded-lg max-w-md dropdown-container">
                    <label class="block mb-2 text-slate-white text-base">
                        {{ 'What is the age range of whom you want to buy insurance for?' | translate }}
                    </label>

                    <div class="relative">
                        <!-- Dropdown button -->
                        <button type="button"
                            class="bg-[#18171A] shadow px-4 py-3 border-none rounded-xl focus:outline-none w-full text-white text-left"
                            (click)="toggleDropdown('AgeRange')">
                            <span class="text-slate-300">
                                {{ selectedAge || ('Select age range' | translate) }}
                            </span>
                            <span class="float-right">&#9662;</span>
                        </button>

                        <!-- Dropdown list -->
                        <div *ngIf="activeDropdown === 'AgeRange'"
                            class="z-10 absolute bg-[#18171A] shadow-lg mt-2 border border-[#232124] rounded-xl w-full max-h-60 overflow-y-auto">
                            <div *ngFor="let item of age" (click)="selectAge(item); closeDropdown()"
                                class="hover:bg-[#232124] px-4 py-2 rounded-xl cursor-pointer"
                                [ngClass]="item === selectedAge ? 'text-[#F03457] font-semibold' : 'text-white'">
                                {{ item | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Consent -->
                <div class="shadow-lg mx-auto mb-4 rounded-lg max-w-md">
                    <div class="flex items-start">
                        <div>
                            <label class="inline-block relative mt-1.5 align-middle">
                                <input id="consent" type="checkbox" formControlName="consent"
                                    class="peer bg-[#121212] checked:bg-[#F03457] border-[#3C3C3C99] border-2 rounded focus:outline-none w-[28px] h-[28px] appearance-none" />
                                <span
                                    class="top-0 left-0 absolute flex justify-center items-center bg-[#F03457] opacity-0 peer-checked:opacity-100 rounded w-[28px] h-[28px] transition-opacity pointer-events-none">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 10.5L9 14.20L15 7.5" stroke="black" stroke-width="4"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </label>
                        </div>
                        <div class="ml-3 font-primary text-slate-white text-sm">
                            <label for="consent" class="font-primary text-[#958D90]">
                                {{'I agree that LivWell may collect, provide, and share all information I have submitted
                                in this form with Asahi, so
                                that Asahi may contact me to provide consultation and offer the Income Protection
                                insurance co-provided by Asahi and PVI. In
                                return, Asahi will update LivWell with the contact status for reconciliation purposes
                                between the parties.'|
                                translate}}
                            </label>
                            @if (form.get('consent')?.invalid && (form.get('consent')?.touched ||
                            form.get('consent')?.dirty)) {
                            <div class="mt-2 text-[#F03457]">
                                <span>{{ 'You must consent to the terms and conditions to proceed.' | translate
                                    }}</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Submit Button -->
        <div class="right-0 bottom-0 left-0 z-20 fixed bg-[#141011] p-4 w-full">
            <button type="button" (click)="onSubmit()" [disabled]="isLoading || form.invalid"
                class="px-3 py-4 rounded-[4px] w-full font-primary font-bold text-lg transition-all duration-300 flex justify-center items-center gap-2"
                [ngClass]="{
          'bg-secondary text-white': !form.invalid && !isLoading,
          'bg-[#5A5657] text-gray-200': form.invalid || isLoading
        }">

                <span *ngIf="!isLoading">{{ 'Submit' | translate }}</span>

                <span *ngIf="isLoading" class="flex items-center gap-2">
                    <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                        </circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                    </svg>
                                            {{'Loading...' | translate}}
                </span>

            </button>
        </div>
    </div>
</div>
    <!--OTP-->
    <app-asahi-otp-modal [asahi]="true" [visible]="showOtpModal" [phoneMasked]="otpPhoneMasked"
        [countryCode]="otpCountryCode" [mobileNo]="otpMobileNo" [errorMsg]="otpErrorMsg" [loading]="otpLoading"
        (verified)="onOtpVerified($event)" (closed)="onOtpClosed()" (edit)="onOtpEdit()"
        (zaloVerify)="onOtpZaloVerify()" (callVerify)="onOtpCallVerify()"></app-asahi-otp-modal>